import { LazyModalWhatsNew } from "#components";

export type WhatsNewPayload = {
  id: string;
  enabled: boolean;
  publishedAt?: string;
  title: string;
  summary?: string;
  items: string[];
  bannerImage?: string;
  changelogUrl?: string;
};

const STORAGE_KEY = "whats_new_seen_id";

export const useWhatsNew = () => {
  const modalManager = useModalManager();

  const markSeen = (id: string) => {
    if (!process.client) return;
    localStorage.setItem(STORAGE_KEY, id);
  };

  const getSeenId = () => {
    if (!process.client) return "";
    return localStorage.getItem(STORAGE_KEY) || "";
  };

  const fetchPayload = async (): Promise<WhatsNewPayload | null> => {
    try {
      const payload = await $fetch<WhatsNewPayload>("/whats-new.json", {
        cache: "no-store",
      });
      if (!payload?.id || !Array.isArray(payload.items)) return null;
      return payload;
    } catch {
      return null;
    }
  };

  const openModal = (payload: WhatsNewPayload, preview = false) => {
    modalManager.openModal({
      id: preview ? "modal-whats-new-preview" : "modal-whats-new",
      component: LazyModalWhatsNew,
      props: {
        payload,
        preview,
      },
    });
  };

  const maybeOpenWhatsNew = async () => {
    const payload = await fetchPayload();
    if (!payload || !payload.enabled) return;

    const seenId = getSeenId();
    if (seenId === payload.id) return;

    openModal(payload, false);
  };

  return {
    STORAGE_KEY,
    fetchPayload,
    markSeen,
    getSeenId,
    maybeOpenWhatsNew,
    openModal,
  };
};
